import { useEffect, useState } from "react";
import { useStore } from "@/store";
import { Navigate, Outlet } from "react-router-dom";

const SuperadminProtectedRoute = ({ children }) => {
  const loggedInUser = useStore((state) => state.loggedInUser);
  const [isHydrated, setIsHydrated] = useState(
    () => useStore.persist?.hasHydrated?.() || false,
  );

  useEffect(() => {
    const finishHydration = useStore.persist?.onFinishHydration?.(() =>
      setIsHydrated(true),
    );
    const startHydration = useStore.persist?.onHydrate?.(() =>
      setIsHydrated(false),
    );

    return () => {
      finishHydration?.();
      startHydration?.();
    };
  }, []);

  let persistedUser = null;
  try {
    const rawStore = localStorage.getItem("store");
    if (rawStore) {
      const maybeParsed = JSON.parse(rawStore);
      const parsed =
        typeof maybeParsed === "string" ? JSON.parse(maybeParsed) : maybeParsed;

      persistedUser = parsed?.state?.loggedInUser || parsed?.loggedInUser || null;
    }
  } catch (error) {
    console.error("Error reading persisted user:", error);
  }

  const effectiveUser = loggedInUser?.roles?.length ? loggedInUser : persistedUser;

  useEffect(() => {
    if (!loggedInUser?.roles?.length && persistedUser?.roles?.length) {
      useStore.setState((state) => ({
        ...state,
        loggedInUser: persistedUser,
      }));
    }
  }, [loggedInUser, persistedUser]);

  const isSuperadmin =
    Array.isArray(effectiveUser?.roles) &&
    effectiveUser.roles.includes("superadmin");

  if (!isHydrated && !effectiveUser) {
    return null;
  }

  if (!isSuperadmin) {
    return <Navigate to="/admin/settings" replace={true} />;
  }

  return children ? children : <Outlet />;
};

export default SuperadminProtectedRoute;
